import React from 'react'

function AttendanceByMember({ color = '#252C32', bgColor = 'white' }) {
    return (
        <>
            <svg width="24" height="24" viewBox="0 0 16 17" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
                <path d="M9.33333 4.50065C9.33333 5.97341 8.1394 7.16732 6.66667 7.16732C5.19391 7.16732 4 5.97341 4 4.50065C4 3.02789 5.19391 1.83398 6.66667 1.83398C8.1394 1.83398 9.33333 3.02789 9.33333 4.50065Z" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.3332 13.1673L11.3332 12.7673V11.1673M8.6665 12.5007C8.6665 13.9734 9.86044 15.1673 11.3332 15.1673C12.8059 15.1673 13.9998 13.9734 13.9998 12.5007C13.9998 11.0279 12.8059 9.83398 11.3332 9.83398C9.86044 9.83398 8.6665 11.0279 8.6665 12.5007Z" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7 13.8327H3.33333C2.59695 13.8327 2 13.2357 2 12.4993C2 10.6584 3.49239 9.16602 5.33333 9.16602H8.33333" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    )
}

export default AttendanceByMember
